import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=5356405c&scoped=true&"
import script from "./Menubar.vue?vue&type=script&lang=js&"
export * from "./Menubar.vue?vue&type=script&lang=js&"
import style0 from "./Menubar.vue?vue&type=style&index=0&id=5356405c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356405c",
  null
  
)

export default component.exports